import { render, staticRenderFns } from "./entity-issue-task.vue?vue&type=template&id=07e201f8"
import script from "./entity-issue-task.vue?vue&type=script&lang=js"
export * from "./entity-issue-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports